import axios from 'axios';
import swal from 'sweetalert2';
import store from '../store';
import router from '../router';

axios.interceptors.request.use((request) => {
  request.baseURL = window.localStorage.getItem('instanceURL') || process.env.VUE_APP_API_ENDPOINT;

  if (store.getters['auth/token']) {
    request.headers.common.Authorization = `Bearer ${store.getters['auth/token']}`;
  }
  request.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  request.headers.common['X-Requested-Application'] = 'webapp';
  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request;
});

axios.interceptors.response.use(response => response, async (error) => {
  const { status } = error.response;

  if (status >= 500) {
    swal({
      type: 'error',
      confirmButtonClass: 'button',
      buttonsStyling: false,
      title: swal.i18n.t('errors.alert_title'),
      text: swal.i18n.t('errors.alert_text')
    });
  }

  if (status === 401 && store.getters['auth/check']) {
    /*
    if (store.getters['auth/expire'] instanceof Date && store.getters['auth/expire'] >= new Date()) {
      location.reload();
    }

    const refreshed = await store.dispatch('auth/refreshOrLogout');

    if (refreshed) {
      error.config.headers.Authorization = `Bearer ${store.getters['auth/token']}`;

      return axios.request(error.config);
    }
    */

    await store.dispatch('auth/logout');
    router.push({ name: 'login' });

    swal({
      type: 'warning',
      confirmButtonClass: 'button',
      buttonsStyling: false,
      title: swal.i18n.t('errors.token_expired_alert_title'),
      text: swal.i18n.t('errors.token_expired_alert_text')
    });
  }

  return Promise.reject(error);
});
